import { isAnyOf, startListening } from '@bonanza-social/toolkit/state';
import {
  getAccount,
  setAccount,
  requestTimeout,
  selectAccountStatus,
  selectAccountStatusReason,
} from '@bonanza-social/account/state';
import { setEligibilityError } from '@bonanza-social/prize-wall/state';

startListening({
  matcher: isAnyOf(getAccount.fulfilled, requestTimeout.fulfilled, setAccount),
  effect: (_, { dispatch, getState }) => {
    const accountStatus = selectAccountStatus(getState());
    const accountStatusReason = selectAccountStatusReason(getState());

    if (accountStatus === 'Timeout') {
      dispatch(setEligibilityError('UserInTimeoutError'));

      return;
    }

    if (
      accountStatus === 'Pending' &&
      (accountStatusReason === 'KYC incomplete' ||
        accountStatusReason === 'KYC in progress')
    ) {
      dispatch(setEligibilityError('UserNotVerifiedError'));

      return;
    }

    setEligibilityError(undefined);
  },
});
